import { render, staticRenderFns } from "./bout_destroy.vue?vue&type=template&id=9646a14e&"
import script from "./bout_destroy.vue?vue&type=script&lang=js&"
export * from "./bout_destroy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports